module.exports = __webpack_public_path__ + "static/media/FuturaPTBoldOblique.a6a256a5.otf";